'use client';

import { createContextStore } from '@eliadmin/core/src/stores/context-store';

/** Shared between the burger button in the main row and the drawer rendered with the navigation. */
export const [HeaderDrawerProvider, useHeaderDrawer] = createContextStore<
  { isOpen: boolean },
  { open: () => void; close: () => void }
>({ isOpen: false }, set => ({
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
